import { useState, useEffect } from 'react';
import { Button, Combobox, Sheet } from '@elbklar/ui';
import { TextareaField } from '@/components/form/Felder';

const PREDEFINED_REASONS = [
  'Preis zu hoch',
  'Konkurrenz gewählt',
  'Kein Bedarf',
  'Falscher Zeitpunkt',
  'Nicht erreichbar',
  'Sonstiges',
] as const;

type PredefinedReason = (typeof PREDEFINED_REASONS)[number];

interface LostReasonModalProps {
  open: boolean;
  onCancel: () => void;
  onSubmit: (reason: string) => void;
}

export function LostReasonModal({ open, onCancel, onSubmit }: LostReasonModalProps) {
  const [selected, setSelected] = useState<PredefinedReason | ''>('');
  const [freitext, setFreitext] = useState('');

  useEffect(() => {
    if (open) {
      setSelected('');
      setFreitext('');
    }
  }, [open]);

  const isSonstiges = selected === 'Sonstiges';
  const freitextTrimmed = freitext.trim();
  const canSubmit = selected !== '' && (!isSonstiges || freitextTrimmed.length > 0);

  const handleSubmit = () => {
    if (!canSubmit) return;
    const reason = isSonstiges ? freitextTrimmed : (selected as string);
    onSubmit(reason);
  };

  const options = PREDEFINED_REASONS.map((r) => ({ value: r, label: r }));

  return (
    <Sheet
      open={open}
      onOpenChange={(offen) => !offen && onCancel()}
      title="Grund für Verloren"
      footer={
        <>
          <Button variant="ghost" onClick={onCancel}>
            Abbrechen
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={!canSubmit}>
            Grund speichern
          </Button>
        </>
      }
    >
      <div className="space-y-4">
        <Combobox
          label="Grund"
          options={options}
          value={selected}
          onChange={(v) => setSelected(v as PredefinedReason | '')}
          placeholder="Grund wählen"
          required
        />
        {isSonstiges && (
          <TextareaField
            label="Freitext"
            required
            value={freitext}
            onChange={(e) => setFreitext(e.target.value)}
            rows={3}
            placeholder="Grund beschreiben"
          />
        )}
      </div>
    </Sheet>
  );
}
